import { defineRouting } from 'next-intl/routing'
import { supportedLocales } from '../../../../constants'

export const defaultLocale = 'en-US'

export const routing = defineRouting({
  locales: supportedLocales,
  defaultLocale,
  localePrefix: 'as-needed',
})
